export default "__VITE_ASSET__989cc611__"